/* 상품 가격 — 결제수단별 안내의 투그릭 금액을 채운다.
 *
 * ─── 환율은 어디서 오는가 ──────────────────────────────────────────────────
 *
 * 단일 관리처는 **TMS** 다 (/api/fx/current). 담당자가 TMS 에서 '적용' 한 값만
 * 나온다 — 실시간 시세를 따라가지 않는다. Khan Bank 계좌이체는 고객이 그 금액을
 * 실제로 입금하므로, 시시각각 바뀌면 입금액과 주문이 어긋난다.
 *
 * theme.liquid 의 #tg-fx[data-fb-mnt] 는 **폴백**으로 남긴다. 계좌이체 금액
 * 자리라 빈칸이 되면 안 되므로, 네트워크를 기다리지 않고 먼저 이 값으로 그린 뒤
 * 응답이 오면 교체한다. TMS 가 죽어도 숫자는 계속 보인다.
 *
 * ─── 반올림은 올림이다 ─────────────────────────────────────────────────────
 *
 * TMS lib/fx/quotes.ts 의 depositAmount() 와 같은 정수 연산을 쓴다. 두 곳이
 * 갈리면 TMS 가 계산한 입금액과 화면 금액이 다르다.
 *
 * 라벨(한국어/몽골어/영어)은 snippets/price.liquid 에서 tengergo-copy 로 렌더하고,
 * 이 스크립트는 숫자만 채운다.
 *
 * ─── 통화는 투그릭 하나다 ─────────────────────────────────────────────────
 *
 * 2026-10-20 에 한국어 화면의 원화 참고 표시를 거뒀다 (로케일 무관 ₮).
 * 원화 환산(data-fb-krw · data-krw-note)도 함께 지웠다 — 쓰는 곳이 없는 채로
 * 남겨 두면 다음에 읽는 사람이 아직 원화를 찍는다고 믿는다.
 */
(function () {
  /**
   * 투그릭 입금액 반올림 단위. **올림이다.**
   *
   * 덜 받으면 손실이고, 더 받으면 고객이 알아차린다 — 그래서 단위를 작게 둔다.
   * 100 투그릭은 2026년 환율로 약 $0.03 이다.
   *
   * TMS 의 lib/fx/quotes.ts depositAmount() 와 같은 규칙이어야 한다. 두 곳이
   * 갈리면 TMS 가 계산한 입금액과 화면에 찍힌 금액이 달라진다.
   */
  var ROUND = 100;

  /** 환율 스케일 — 1/10000. TMS 와 같은 단위로 맞춰 정수만 다룬다 */
  var RATE_SCALE = 10000;

  var API = 'https://tengergo-tms.vercel.app/api/fx/current';
  var CACHE_KEY = 'tg_fx_quote_v1';
  var CACHE_TTL_MS = 6 * 60 * 60 * 1000;
  var TIMEOUT_MS = 1500;

  /** 정수 나눗셈 올림. Math.ceil(a/b) 는 몫이 정수에 가까울 때 한 단위 어긋난다 */
  function ceilDiv(numerator, denominator) {
    var remainder = numerator % denominator;
    return remainder === 0 ? (numerator - remainder) / denominator : (numerator - remainder) / denominator + 1;
  }

  /**
   * USD 센트 → 입금액(통화 최소단위), 단위 올림.
   *
   * **환율을 1/10000 정수(rateE4)로 받는다.** 실수를 받아 여기서 곱하면 돈 계산
   * 경로에 부동소수점이 한 번 들어간다. TMS 응답의 rateScaled 를 그대로 쓰면
   * 그 한 번도 없앨 수 있다 — 입력 단계에서 정수로 만들어 넘긴다.
   */
  function depositAmount(cents, rateE4, unit) {
    return ceilDiv(ceilDiv(cents * rateE4, 100 * RATE_SCALE), unit) * unit;
  }

  function fixedRate(attr) {
    var tag = document.getElementById('tg-fx');
    if (!tag) return 0;
    var v = parseFloat(tag.getAttribute(attr));
    return isFinite(v) && v > 0 ? v : 0;
  }

  /**
   * 폴백 환율을 1/10000 정수로. API 응답이 오면 교체된다.
   *
   * data-fb-mnt 는 속성 문자열이라 여기서 한 번은 실수를 거친다. 피할 수 없고,
   * 폴백은 어차피 손으로 넣은 근사값이다. API 경로는 rateScaled 로 이 단계가 없다.
   */
  /* ━━ 안전장치 ━━ 스토어 통화가 USD 가 아니면 아무것도 하지 않는다.
   *
   * 이 스크립트는 data-amount-cents 가 **USD 센트**라고 보고 환율을 곱한다.
   * 스토어 통화가 바뀌면 그 가정이 깨진다.
   *
   * 2026-10-19 에 통화를 MNT 로 바꿨을 때, Shopify 가 가격 숫자를 변환하지
   * 않아 40.99 가 그대로 남았는데 여기서 3,619 를 곱해 ₮148,400 을 찍었다.
   * 체크아웃은 ₮40.99(약 16원)였다. 가격이 망가진 것을 이 스크립트가 가렸다.
   *
   * Liquid 쪽(tg-money.liquid)에도 같은 가드가 있다. 둘 다 있어야 한다 —
   * 서버가 멈춰도 여기서 다시 칠하면 소용이 없다.
   */
  var shopCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
  if (shopCurrency && shopCurrency !== 'USD') return;

  var rateE4 = Math.round(fixedRate('data-fb-mnt') * RATE_SCALE);
  var unit = ROUND;
  if (!rateE4) return;

  function group(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }



  function render() {
    var nodes = document.querySelectorAll('[data-converted-price]:not([data-converted-done])');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var cents = parseFloat(el.getAttribute('data-amount-cents'));
      if (!isFinite(cents) || cents <= 0) continue;

      var amount = depositAmount(cents, rateE4, unit);

      var amountEl = el.querySelector('[data-khan-amount]');
      if (amountEl) amountEl.textContent = '₮' + group(amount);

      var rateEl = el.querySelector('[data-khan-rate]');
      if (rateEl && !rateEl.textContent) {
        var tpl = rateEl.getAttribute('data-template') || '';
        var shown = group(Math.round(rateE4 / RATE_SCALE));
        rateEl.textContent = tpl ? tpl.replace('{rate}', shown) : '₮' + shown;
      }

      el.setAttribute('data-converted-done', '1');
    }
  }

  /**
   * 환율이 바뀌면 이미 그린 노드를 다시 그려야 한다.
   * done 플래그만 걷어내고 render() 를 다시 돌린다.
   */
  function rerender() {
    var done = document.querySelectorAll('[data-converted-done]');
    for (var i = 0; i < done.length; i++) {
      done[i].removeAttribute('data-converted-done');
      var rateEl = done[i].querySelector ? done[i].querySelector('[data-khan-rate]') : null;
      if (rateEl) rateEl.textContent = '';
    }
    render();
  }

  /**
   * 유효한 응답이면 환율을 갈아끼우고 다시 그린다.
   *
   * scaled(1/10000 정수)가 있으면 그것을 쓴다. 없을 때만 실수에서 환산한다 —
   * 돈 계산에 들어가는 부동소수점 연산을 응답이 허용하는 만큼 줄인다.
   */
  function applyQuote(mnt, roundingUnit, scaled) {
    var next = null;
    if (typeof scaled === 'number' && isFinite(scaled) && scaled > 0 && scaled % 1 === 0) {
      next = scaled;
    } else if (typeof mnt === 'number' && isFinite(mnt) && mnt > 0) {
      next = Math.round(mnt * RATE_SCALE);
    }
    if (next === null) return false;
    rateE4 = next;
    if (typeof roundingUnit === 'number' && isFinite(roundingUnit) && roundingUnit >= 1) {
      unit = Math.round(roundingUnit);
    }
    rerender();
    return true;
  }

  function readCache() {
    try {
      var o = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (!o || !o.t || Date.now() - o.t > CACHE_TTL_MS) return null;
      return o;
    } catch (e) { return null; }
  }

  function writeCache(mnt, roundingUnit, scaled) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), r: mnt, u: roundingUnit, s: scaled }));
    } catch (e) {}
  }

  /**
   * TMS 조회. **실패는 조용히 넘긴다** — 폴백 값이 이미 화면에 있다.
   * 재시도도 에러 UI 도 없다. 계좌이체 금액 자리에 경고를 띄울 이유가 없다.
   */
  function fetchQuote() {
    if (typeof fetch !== 'function') return;

    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, TIMEOUT_MS);

    fetch(API, controller ? { signal: controller.signal } : undefined)
      .then(function (res) {
        if (!res.ok) throw new Error('fx http ' + res.status);
        return res.json();
      })
      .then(function (data) {
        clearTimeout(timer);
        var mnt = data && data.rates ? data.rates.MNT : undefined;
        var ru = data && data.roundingUnit ? data.roundingUnit.MNT : undefined;
        /** quotes[] 에 1/10000 정수(rateScaled)가 있으면 그쪽이 우선이다 */
        var scaled;
        var quotes = data && data.quotes;
        if (quotes && quotes.length) {
          for (var q = 0; q < quotes.length; q++) {
            if (quotes[q] && quotes[q].currency === 'MNT') { scaled = quotes[q].rateScaled; break; }
          }
        }
        if (applyQuote(mnt, ru, scaled)) writeCache(mnt, ru, scaled);
      })
      .catch(function () { clearTimeout(timer); });
  }

  function boot() {
    // 1) 폴백으로 먼저 그린다. 네트워크를 기다리지 않는다
    render();

    // 2) 캐시가 살아 있으면 즉시 교체
    var cached = readCache();
    if (cached) applyQuote(cached.r, cached.u, cached.s);

    // 3) 캐시가 없을 때만 조회한다
    if (!cached) fetchQuote();
    if (!window.MutationObserver) return;
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; render(); }, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
